module.exports = __webpack_public_path__ + "static/media/S (103).7b71855d.jpg";